import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search: "",
  unCheckedProjects: [],
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    filtered: (state, action) => {
      // if project checked then add the project else remove the project
      if (action.payload.checked) {
        const updatedProjects = state.unCheckedProjects?.filter(
          (project) => project.id !== action.payload.data.id
        );
        state.unCheckedProjects = updatedProjects;
      } else {
        state.unCheckedProjects.push(action.payload.data);
      }
    },
    searched: (state, action) => {
      state.search = action.payload;
    },
  },
});

export default filterSlice.reducer;
export const { filtered, searched } = filterSlice.actions;
